// extracted by mini-css-extract-plugin
module.exports = {"layout":"src-containers-RulesOld-Main-styles___layout","sidebarHeading":"src-containers-RulesOld-Main-styles___sidebarHeading"};